<template>
  <div class="bkgj">
    <div class="u-p5-x-3">
      <template>
         <h4 style="color: aliceblue;margin-top: -30px">
           布控告警
         </h4>
       </template>
      <car-form
        @submit="submit"
        :defaultFormValue="timeType"
        :showformitem="formItemshow"
      ></car-form>
    </div>
    <div style="padding: 0 20px">
      <car-img-list
        v-if="imageList.length > 0"
        @carshow="carimgShow"
        :key="refreshKey"
        :image-list="imageList"
        :showlistitem="['cartime', 'plateNumber']"
      ></car-img-list>
      <div
        style="text-align: center; color: #b3b3b3; padding-top: 1rem"
        v-if="loading == true"
      >
        <i style="font-size: 0.28rem" class="el-icon el-icon-loading"></i>
      </div>
      <div
        v-if="imageList.length == 0 && loading == false"
        style="text-align: center; color: #b3b3b3; padding-top: 1rem"
      >
        查询结果为空
      </div>
    </div>
  </div>
</template>

<script>
import CarForm from "@/components/form/carForm.vue";
import CarImgList from "@/components/carImgList.vue";
export default {
  components: {
    CarForm,
    CarImgList,
  },
  data() {
    const timeType = {
      beginTime: this.$myPlug.timeFormat(
        new Date().getTime() - 60000 * 60 * 24 * 7,
        "yyyy-mm-dd hh:MM:ss"
      ),
      endTime: this.$myPlug.timeFormat(new Date().getTime(), "yyyy-mm-dd hh:MM:ss"),
    };
    return {
      loading: false,
      timeType: {
        0: [timeType.beginTime, timeType.endTime],
      },
      defaultFormValue: {
        passingTime: Object.values(timeType),
      },
      form: {
        ...timeType,
      },
      pageRow: 10,
      pageIndex: 1,
      refreshKey: "t1",
      formItemshow: [
        "plateNo",
        "plateClass",
        "timeType2",
        "dispositionID",
        "dispositionType",
        "deviceType",
      ],
      imageList: [],
    };
  },
  methods: {
    submit(form) {
      this.form = form;
      switch (this.form.timeType) {
        case "0":
          if (!this.form.hasOwnProperty("0") || this.form["0"] == null) {
            this.$message.error("告警时间不能为空");
            return;
          }
          this.form.beginTime = this.form["0"][0];
          this.form.endTime = this.form["0"][1];
          break;
        case "1":
          if (!this.form.hasOwnProperty("1") || this.form["1"] == null) {
            this.$message.error("过车时间不能为空");
            return;
          }
          this.form.beginTime = this.form["1"][0];
          this.form.endTime = this.form["1"][1];
          break;

      }
      this.pageIndex = 1;
      this.getList();
    },
    carimgShow(data) {
      console.log(3333);
      console.log(data);
      this.$store.commit("boxDetail", {
        carList: data,
        showCard: ["过车信息", "数据信息"],
        title: "详情",
      });
    },
    getList() {
      this.loading = true;
      this.form.pageIndex = this.pageIndex;
      this.form.pageRow = this.pageRow;
      this.$http
        .POST_hyNotificationPage(this.form)
        .then((response) => {
          if (response.data) {
            this.loading = false;
            this.imageList = [];
            response.data.forEach((item, index) => {
              this.imageList.push(
                Object.assign({}, item, {
                  img: item.thumbnailUrl || "../../static/img/img_error2.png",
                  largeImg: item.storageUrl1,
                  cartime: item.passingTimeFormat,
                  tollgate: item.tollgateName,
                  plateNumber: item.plateNo,
                  plateColor: item.plateColor,
                })
              );
            });
            this.refreshKey = new Date().getTime();
          } else {
            this.$message.error(response.msg);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error("检测网络");
        });
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/yjbk/bkgj.vue